module.exports = __webpack_public_path__ + "static/media/LK.3ccfa8ad.png";